export const baseUrl = "https://api.meetmark.ai";
// export const baseUrl = "http://localhost:4000";

// export const homepageUrl = "http://localhost:3001";
export const homepageUrl = "https://meetmark.ai/";

// export const appUrl = "http://localhost:3000";
export const appUrl = "https://app.meetmark.ai/";
